import React from 'react';

import CenterContent from '../components/CenterContent';

class NoUnifiedAttributes extends React.Component {
  render() {
    return (
      <CenterContent>
        <div>You have no unified attributes.</div>
      </CenterContent>
    );
  }
}

export default NoUnifiedAttributes;
